import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-3 row" }
const _hoisted_2 = { class: "col-sm-9" }
const _hoisted_3 = {
  key: 0,
  class: "mb-3 row"
}
const _hoisted_4 = { class: "col-sm-9" }
const _hoisted_5 = {
  key: 1,
  class: "mb-3 row"
}
const _hoisted_6 = { class: "col-sm-9" }
const _hoisted_7 = {
  key: 2,
  class: "mb-3 row"
}
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = {
  key: 3,
  class: "mb-3 row"
}
const _hoisted_10 = { class: "col-sm-9" }
const _hoisted_11 = {
  key: 4,
  class: "mb-3 row"
}
const _hoisted_12 = { class: "col-sm-9" }
const _hoisted_13 = {
  key: 5,
  class: "mb-3 row"
}
const _hoisted_14 = { class: "col-sm-9" }
const _hoisted_15 = {
  key: 6,
  class: "mb-3 row"
}
const _hoisted_16 = { class: "col-sm-9" }
const _hoisted_17 = {
  key: 7,
  class: "mb-3 row"
}
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = {
  key: 8,
  class: "mb-3 row"
}
const _hoisted_20 = { class: "col-sm-9" }
const _hoisted_21 = { class: "mb-4 row" }
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = {
  key: 9,
  class: "mb-3 row"
}
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = { class: "col align-content-center text-end" }
const _hoisted_27 = {
  key: 10,
  class: "mb-4 row"
}
const _hoisted_28 = { class: "col-sm-9 mt-2" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "row mb-2" }
const _hoisted_31 = { class: "col-7" }
const _hoisted_32 = { class: "col-3 text-center align-content-center" }
const _hoisted_33 = { class: "form-check-inline" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "col-1 align-content-center" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "mt-3" }
const _hoisted_38 = { class: "mb-4 row" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = {
  class: "table table-light table-striped",
  style: {"table-layout":"fixed"}
}
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-start" }
const _hoisted_44 = ["onUpdate:modelValue", "disabled"]
const _hoisted_45 = ["onUpdate:modelValue", "disabled"]
const _hoisted_46 = ["onUpdate:modelValue", "disabled"]
const _hoisted_47 = {
  key: 0,
  class: "input-group input-group-sm"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "bi bi-check-lg text-success"
}
const _hoisted_50 = {
  key: 1,
  class: "bi bi-x-lg text-danger"
}
const _hoisted_51 = {
  key: 0,
  class: "bi bi-check-lg text-success"
}
const _hoisted_52 = {
  key: 1,
  class: "bi bi-x-lg text-danger"
}
const _hoisted_53 = { class: "button-wrapper" }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = {
  class: "btn-group",
  role: "group"
}

import {computed, onMounted, ref} from "vue";
import {BTableColumn} from "./BTable/BTable.types";
import {useUserStore} from "@/stores/userStore";
import {FormModal, InformationModal, SystemAlerts} from "./Misc";
import BGrid from "./BGrid/BGrid.vue";
import type {UserInformation, UserOri, UserField} from "@/types";
import {useFormValidation} from "@/validation";
import {object, string} from "yup";
import * as Yup from "yup";
import {useRoleStore} from "@/stores/roleStore";
import {useAuthStore} from "@/stores/authStore";
import {BSelect, BInput, BPassword, BAgency} from "./Fields";
import {BButton} from "./BButton";
import {BAlert} from "./BAlert";
import {clone} from "@/utils";
import DropDown from "@/components/Misc/DropDown.vue";
import {saveFile} from "@/composable/filesHelper";

import {storeToRefs} from "pinia";

interface UserFieldState {
    visible: boolean;
    required: boolean;
    editable: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Users',
  props: {
    includePasswordField: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const isShowEditEditor = ref(false);
const isShowSettingsEditor = ref(false);
const userStore = useUserStore();
const {loading} = storeToRefs(userStore);
const roleStore = useRoleStore();
const authStore = useAuthStore();

const sorter = [
    "userName",
    "password",
    "firstName",
    "lastName",
    "organization",
    "email",
    "ori",
    "custom1",
    "custom2",
    "custom3",
    "roleName",
    "apiKey",
    "isEnabled",
    "actions",
];

const columns = ref<BTableColumn[]>();
const baseColumns = ref<BTableColumn[]>([
    {
        key: "roleName",
        text: "Role",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.roleName,
    },

    {
        key: "isEnabled",
        text: "Enabled",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.isEnabled,
    },

    {
        key: "actions",
        text: "",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap text-end"],
        value: (item) => item["link"],
    },
]);

const userFieldStates: {[id: string]: UserFieldState} = {};

const canAdd = computed(() => {
    return true;
});
const canDelete = computed(() => {
    return true;
});
const canEdit = computed(() => {
    return true;
});

const userOris = computed(() => {
    return user.value.oris.map((x) => x.ori);
});

const editDialogTitle = computed(() => {
    return selectedUserId.value == -1 ? "Add new user" : `Edit user - ${user.value.userName}`;
});

const user = ref<UserInformation>({} as UserInformation);
const selectedUserId = ref(-1);
const isShowConfirmDelete = ref(false);
const deleteItemConfirm = async (id: number) => {
    isShowConfirmDelete.value = true;
    selectedUserId.value = id;
};

const schema = object<UserInformation>({
    userName: string()
        .required()
        .label("Username")
        .test("username-backend-validation", "Username already exists.", async (username) => {
            return userStore.validateUsername(selectedUserId.value, username);
        }),
    password: string()
        .label("Password")
        .trim()
        .when([], {
            is: () => props.includePasswordField && userFieldStates["password"].required === true,
            then: (schema) => schema.required(),
        })
        .test("password-backend-validation", async (password, {createError}) => {
            if (password && user.value.userName) {
                var errors = await authStore.validateNewPassword(user.value.userName, password!);
                if (errors?.length) {
                    return createError({
                        message: errors[0],
                    });
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }),
    confirmPassword: string()
        .label("Confirm Password")
        .trim()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .when([], {
            is: () => props.includePasswordField && userFieldStates["password"].required === true,
            then: (schema) => schema.required(),
        }),
    firstName: string()
        .nullable()
        .trim()
        .label("First Name")
        .when([], {
            is: () => userFieldStates["firstName"].required === true,
            then: (schema) => schema.required(),
        }),
    lastName: string()
        .nullable()
        .trim()
        .label("Last Name")
        .when([], {
            is: () => userFieldStates["lastName"].required === true,
            then: (schema) => schema.required(),
        }),
    organization: string()
        .label("Organization")
        .trim()
        .when([], {
            is: () => userFieldStates["organization"].required === true,
            then: (schema) => schema.required(),
        }),
    email: string()
        .nullable()
        .trim()
        .email()
        .label("Email")
        .when([], {
            is: () => userFieldStates["email"].required === true,
            then: (schema) => schema.required().email(),
        }),
    custom1: string()
        .nullable()
        .trim()
        .label("Custom1")
        .when([], {
            is: () => userFieldStates["custom1"].required === true,
            then: (schema) => schema.required(),
        }),
    custom2: string()
        .nullable()
        .trim()
        .label("Custom2")
        .when([], {
            is: () => userFieldStates["custom2"].required === true,
            then: (schema) => schema.required(),
        }),
    custom3: string()
        .nullable()
        .trim()
        .label("Custom3")
        .when([], {
            is: () => userFieldStates["custom3"].required === true,
            then: (schema) => schema.required(),
        }),

    roleId: string().required().label("Role"),
});

const createUser = async () => {
    if (await handleSubmit(schema, user.value)) {
        if (selectedUserId.value == -1) {
            await userStore.create(user.value);
        } else {
            await userStore.update(selectedUserId.value, user.value);
        }

        isShowEditEditor.value = false;
        await getData();
    }
};

const exportData = async (type: string) => {
    let blob = await userStore.exportFile(type);    
    saveFile(`users.${type}`, blob);
};

const roles = computed(() => {
    return roleStore.items?.map((x) => ({value: x.roleId, text: x.roleName}));
});

const deleteItem = async () => {
    await userStore.deleteItem(selectedUserId.value);
    await getData();
};

const showEditEditor = async (userId: number) => {
    selectedUserId.value = userId;
    resetValidation();

    if (userId == -1) {
        user.value = {} as UserInformation;
        user.value.isEnabled = true;
        user.value.oris = [{ori: "", allowUpload: true}];
        let defaultItem = roleStore.items?.find((x) => x.defaultFlag);
        if (defaultItem) {
            user.value.roleId = defaultItem.roleId;
        }
    } else {
        user.value = await userStore.getById(userId);
        user.value.confirmPassword = user.value.password;
    }
    isShowEditEditor.value = true;
};

const settingFields = ref<UserField[]>();

const showSettingsEditor = async () => {
    isShowSettingsEditor.value = true;
    settingFields.value = clone(
        userStore.userFields!.sort(function (a, b) {
            if (sorter.indexOf(a["fieldName"]) > sorter.indexOf(b["fieldName"])) {
                return 1;
            } else {
                return -1;
            }
        })
    );
};

const updateSettings = async () => {
    await userStore.updateSettings(settingFields.value!);
    await loadUserFields();
    isShowSettingsEditor.value = false;
};

const getData = async () => {
    await userStore.list();
};

const addApiKey = async () => {
    user.value.apiKey = await userStore.generateApiKey(selectedUserId.value);
};

const removeApiKey = async () => {
    user.value.apiKey = "";
};

const copyApiKey = async (key: string) => {
    navigator.clipboard.writeText(key);
};

const loadUserFields = async () => {
    await userStore.listUserFields();

    columns.value = clone(baseColumns.value);
    userStore!.userFields!.forEach(function (value) {
        userFieldStates[value.fieldName] = {
            visible: value.visible,
            editable: value.editable,
            required: value.required,
        };

        if (value.visible) {
            columns.value!.push({
                key: value.fieldName,
                text: value.label,
                sortable: true,
                columnClass: ["align-top"],
                class: (item) => ["text-nowrap"],
                value: (item) => item[value.fieldName],
            });
        }
    });

    columns.value = columns.value
        .filter((o) => o.key != "password")
        .sort(function (a, b) {
            if (sorter.indexOf(a["key"]) > sorter.indexOf(b["key"])) {
                return 1;
            } else {
                return -1;
            }
        });
};

const deleteOri = async (index: number) => {
    user.value.oris.splice(index, 1);
};
const addOri = async () => {
    user.value.oris.push({allowUpload: true} as UserOri);
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

onMounted(async () => {
    await loadUserFields();
    await roleStore.list();
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(InformationModal), {
      title: "Delete",
      "show-footer": true,
      width: 450,
      className: "confirm",
      modelValue: isShowConfirmDelete.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowConfirmDelete).value = $event))
    }, {
      footer: _withCtx(() => [
        _cache[22] || (_cache[22] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal"
        }, " No ", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          "data-bs-dismiss": "modal",
          onClick: _withModifiers(deleteItem, ["prevent"])
        }, " Yes ")
      ]),
      default: _withCtx(() => [
        _cache[23] || (_cache[23] = _createTextVNode(" Are You Sure? "))
      ]),
      _: 1,
      __: [23]
    }, 8, ["modelValue"]),
    _createVNode(_unref(FormModal), {
      title: editDialogTitle.value,
      modelValue: isShowEditEditor.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((isShowEditEditor).value = $event)),
      loading: _unref(loading),
      onSubmit: createUser
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_1, [
            _cache[24] || (_cache[24] = _createElementVNode("label", {
              for: "auditorName",
              class: "col-sm-3 col-form-label"
            }, " User name: ", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(BInput), {
                name: "username",
                type: "text",
                modelValue: user.value.userName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.userName) = $event)),
                error: _unref(errors).userName
              }, null, 8, ["modelValue", "error"])
            ])
          ]),
          (userFieldStates['password']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[25] || (_cache[25] = _createElementVNode("label", {
                  for: "password",
                  class: "col-sm-3 col-form-label"
                }, " Password: ", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(BPassword), {
                    name: "password",
                    type: "text",
                    modelValue: user.value.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password) = $event)),
                    "show-password": selectedUserId.value < 0,
                    error: _unref(errors).password
                  }, null, 8, ["modelValue", "show-password", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['password']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[26] || (_cache[26] = _createElementVNode("label", {
                  for: "confirmPassword",
                  class: "col-sm-3 col-form-label"
                }, " Confirm password: ", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(BPassword), {
                    name: "confirmPassword",
                    "show-password": selectedUserId.value < 0,
                    type: "text",
                    modelValue: user.value.confirmPassword,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.confirmPassword) = $event)),
                    error: _unref(errors).confirmPassword
                  }, null, 8, ["show-password", "modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['firstName']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[27] || (_cache[27] = _createElementVNode("label", {
                  for: "firstName",
                  class: "col-sm-3 col-form-label"
                }, " First name: ", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(BInput), {
                    name: "firstName",
                    type: "text",
                    modelValue: user.value.firstName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.firstName) = $event)),
                    error: _unref(errors).firstName
                  }, null, 8, ["modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['lastName']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[28] || (_cache[28] = _createElementVNode("label", {
                  for: "lastName",
                  class: "col-sm-3 col-form-label"
                }, " Last name: ", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(BInput), {
                    name: "lastName",
                    type: "text",
                    modelValue: user.value.lastName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.lastName) = $event)),
                    error: _unref(errors).lastName
                  }, null, 8, ["modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['organization']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[29] || (_cache[29] = _createElementVNode("label", {
                  for: "organization",
                  class: "col-sm-3 col-form-label"
                }, " Organization: ", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(BInput), {
                    name: "organization",
                    type: "text",
                    modelValue: user.value.organization,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.organization) = $event)),
                    error: _unref(errors).organization
                  }, null, 8, ["modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['email']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  for: "email",
                  class: "col-sm-3 col-form-label"
                }, " Email: ", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(BInput), {
                    name: "email",
                    type: "text",
                    modelValue: user.value.email,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.value.email) = $event)),
                    error: _unref(errors).email
                  }, null, 8, ["modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['custom1']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  for: "custom1",
                  class: "col-sm-3 col-form-label"
                }, " Custom1: ", -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(BInput), {
                    name: "custom1",
                    type: "text",
                    disabled: !userFieldStates['custom1'].editable,
                    modelValue: user.value.custom1,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((user.value.custom1) = $event)),
                    error: _unref(errors).custom1
                  }, null, 8, ["disabled", "modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['custom2']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _cache[32] || (_cache[32] = _createElementVNode("label", {
                  for: "custom2",
                  class: "col-sm-3 col-form-label"
                }, " Custom2: ", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(BInput), {
                    name: "custom2",
                    type: "text",
                    disabled: !userFieldStates['custom2'].editable,
                    modelValue: user.value.custom2,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((user.value.custom2) = $event)),
                    error: _unref(errors).custom2
                  }, null, 8, ["disabled", "modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['custom3']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _cache[33] || (_cache[33] = _createElementVNode("label", {
                  for: "custom3",
                  class: "col-sm-3 col-form-label"
                }, " Custom3: ", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_unref(BInput), {
                    name: "custom3",
                    type: "text",
                    disabled: !userFieldStates['custom3'].editable,
                    modelValue: user.value.custom3,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((user.value.custom3) = $event)),
                    error: _unref(errors).custom3
                  }, null, 8, ["disabled", "modelValue", "error"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _cache[34] || (_cache[34] = _createElementVNode("label", {
              for: "role",
              class: "col-sm-3 col-form-label"
            }, " Role: ", -1)),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(BSelect), {
                modelValue: user.value.roleId,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((user.value.roleId) = $event)),
                items: roles.value
              }, null, 8, ["modelValue", "items"])
            ])
          ]),
          (userFieldStates['apiKey']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[38] || (_cache[38] = _createElementVNode("label", {
                  for: "apiKey",
                  class: "col-sm-3 col-form-label"
                }, " Api Key: ", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_unref(BInput), {
                      name: "apiKey",
                      disabled: true,
                      type: "text",
                      modelValue: user.value.apiKey,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((user.value.apiKey) = $event)),
                      error: _unref(errors).apiKey
                    }, null, 8, ["modelValue", "error"]),
                    (user.value.apiKey)
                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "input-group-text",
                          type: "button",
                          id: "button-addon2",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (copyApiKey(user.value.apiKey)), ["prevent"]))
                        }, _cache[35] || (_cache[35] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                            class: "bi bi-copy",
                            viewBox: "0 0 16 16"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                            })
                          ], -1)
                        ]))), [
                          [_directive_tooltip, `Copy Api Key`]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(BButton), {
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (addApiKey()), ["prevent"])),
                    size: "sm",
                    class: "me-2"
                  }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createTextVNode(" Generate Api Key ")
                    ])),
                    _: 1,
                    __: [36]
                  }),
                  _createVNode(_unref(BButton), {
                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (removeApiKey()), ["prevent"])),
                    variant: "danger",
                    size: "sm"
                  }, {
                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                      _createTextVNode(" Remove Api Key ")
                    ])),
                    _: 1,
                    __: [37]
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (userFieldStates['ori']?.visible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[42] || (_cache[42] = _createElementVNode("label", {
                  for: "role",
                  class: "col-sm-3 col-form-label"
                }, " Linked Agencies: ", -1)),
                _createElementVNode("div", _hoisted_28, [
                  (user.value.oris?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "row agency-access mb-3" }, [
                          _createElementVNode("div", { class: "col-7" }, "Agency"),
                          _createElementVNode("div", { class: "col-3" }, "Repository Access"),
                          _createElementVNode("div", { class: "col-1" })
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.oris, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_unref(BAgency), {
                                modelValue: item.ori,
                                "onUpdate:modelValue": ($event: any) => ((item.ori) = $event),
                                "excluded-oris": userOris.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "excluded-oris"])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((item.allowUpload) = $event),
                                  value: "",
                                  id: "flexCheckDefault"
                                }, null, 8, _hoisted_34), [
                                  [_vModelCheckbox, item.allowUpload]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              (canDelete.value)
                                ? (_openBlock(), _createBlock(_unref(BButton), {
                                    key: 0,
                                    onClick: _withModifiers(($event: any) => (deleteOri(index)), ["prevent"]),
                                    variant: "danger",
                                    size: "sm"
                                  }, {
                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                      _createTextVNode(" Delete ")
                                    ])),
                                    _: 2,
                                    __: [39]
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 256))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(_unref(BAlert), { variant: "info" }, {
                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                            _createTextVNode("None")
                          ])),
                          _: 1,
                          __: [41]
                        })
                      ])),
                  _createElementVNode("div", _hoisted_37, [
                    (canAdd.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _withModifiers(addOri, ["prevent"]),
                          class: "btn btn-sm btn-primary"
                        }, " Add an agency "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((user.value.isEnabled) = $event)),
                  id: "enabled"
                }, null, 512), [
                  [_vModelCheckbox, user.value.isEnabled]
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "enabled"
                }, " Enabled ", -1))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "loading"]),
    _createVNode(_unref(FormModal), {
      title: "Settings",
      modelValue: isShowSettingsEditor.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowSettingsEditor).value = $event)),
      width: 450,
      onSubmit: updateSettings
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_41, [
          _cache[44] || (_cache[44] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "text-center" }, [
              _createElementVNode("th", { class: "text-start" }, "Setting"),
              _createElementVNode("th", null, "Visible"),
              _createElementVNode("th", null, "Required"),
              _createElementVNode("th", null, "Editable")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settingFields.value, (item) => {
              return (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                _createElementVNode("td", _hoisted_43, _toDisplayString(item.label), 1),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": ($event: any) => ((item.visible) = $event),
                    type: "checkbox",
                    disabled: !item.visibleEnabled,
                    value: ""
                  }, null, 8, _hoisted_44), [
                    [_vModelCheckbox, item.visible]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": ($event: any) => ((item.required) = $event),
                    type: "checkbox",
                    disabled: !item.requiredEnabled,
                    value: ""
                  }, null, 8, _hoisted_45), [
                    [_vModelCheckbox, item.required]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": ($event: any) => ((item.editable) = $event),
                    type: "checkbox",
                    disabled: !item.editableEnabled,
                    value: ""
                  }, null, 8, _hoisted_46), [
                    [_vModelCheckbox, item.editable]
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(BGrid, {
      caption: "Users",
      tableOptions: _unref(userStore).tableOptions,
      filterableFields: _unref(userStore).filterableFields,
      filterOptions: _unref(userStore).filterOptions,
      onOptionChange: getData,
      items: _unref(userStore).items,
      columns: columns.value,
      loading: _unref(loading)
    }, {
      beforeFilter: _withCtx(() => [
        (canAdd.value)
          ? (_openBlock(), _createBlock(_unref(BButton), {
              key: 0,
              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (showEditEditor(-1)), ["prevent"]))
            }, {
              default: _withCtx(() => _cache[45] || (_cache[45] = [
                _createTextVNode("Add new user")
              ])),
              _: 1,
              __: [45]
            }))
          : _createCommentVNode("", true),
        (canAdd.value)
          ? (_openBlock(), _createBlock(_unref(BButton), {
              key: 1,
              onClick: _withModifiers(showSettingsEditor, ["prevent"])
            }, {
              default: _withCtx(() => _cache[46] || (_cache[46] = [
                _createTextVNode("Settings")
              ])),
              _: 1,
              __: [46]
            }))
          : _createCommentVNode("", true)
      ]),
      "cell.apiKey": _withCtx(({item}) => [
        (item.apiKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createVNode(_unref(BInput), {
                disabled: true,
                type: "text",
                modelValue: item.apiKey,
                "onUpdate:modelValue": ($event: any) => ((item.apiKey) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              (item.apiKey)
                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "input-group-text",
                    type: "button",
                    onClick: _withModifiers(($event: any) => (copyApiKey(item.apiKey)), ["prevent"])
                  }, _cache[47] || (_cache[47] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      fill: "currentColor",
                      class: "bi bi-copy",
                      viewBox: "0 0 16 16"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                      })
                    ], -1)
                  ]), 8, _hoisted_48)), [
                    [_directive_tooltip, `Copy Api Key`]
                  ])
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell.ori": _withCtx(({item}) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.oris, (it) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createTextVNode(_toDisplayString(it.ori) + " ", 1),
            (it.allowUpload)
              ? (_openBlock(), _createElementBlock("i", _hoisted_49))
              : (_openBlock(), _createElementBlock("i", _hoisted_50))
          ]))
        }), 256))
      ]),
      "cell.isEnabled": _withCtx(({item}) => [
        (item.isEnabled)
          ? (_openBlock(), _createElementBlock("i", _hoisted_51))
          : (_openBlock(), _createElementBlock("i", _hoisted_52))
      ]),
      "cell.roleName": _withCtx(({item}) => [
        _createTextVNode(_toDisplayString(item.roleName), 1)
      ]),
      "cell.actions": _withCtx(({item}) => [
        _createElementVNode("div", _hoisted_53, [
          (canEdit.value)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 0,
                onClick: _withModifiers(($event: any) => (showEditEditor(item.userId)), ["prevent"]),
                size: "sm"
              }, {
                default: _withCtx(() => _cache[48] || (_cache[48] = [
                  _createTextVNode(" Edit ")
                ])),
                _: 2,
                __: [48]
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (canDelete.value)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 1,
                onClick: _withModifiers(($event: any) => (deleteItemConfirm(item.userId)), ["prevent"]),
                size: "sm",
                variant: "danger"
              }, {
                default: _withCtx(() => _cache[49] || (_cache[49] = [
                  _createTextVNode(" Delete ")
                ])),
                _: 2,
                __: [49]
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_54))
        ])
      ]),
      pagingStart: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createVNode(DropDown, {
            label: "Export Data",
            "item-count": 2,
            "is-primary-button": true
          }, {
            item1: _withCtx(({item}) => [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (exportData('csv')), ["prevent"]))
              }, "Download as .csv")
            ]),
            item2: _withCtx(({item}) => [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (exportData('xlsx')), ["prevent"]))
              }, "Download as .xlsx")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"]),
    _createVNode(_unref(SystemAlerts))
  ], 64))
}
}

})